import VerticalSolidSeparator from './VerticalSolidSeparator';

export default VerticalSolidSeparator;
